// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1s9Dx","colMin":"styles_colMin__3kXdY","colCheckbox":"styles_colCheckbox__195Kj"};